/*!

=========================================================
* Light Bootstrap Dashboard React - v2.0.0
=========================================================

* Product Page: https://www.huaca.gob.ec/gadhuaca//product/light-bootstrap-dashboard-react
* Copyright 2020 Creative Tim (https://www.huaca.gob.ec/gadhuaca/)
* Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import { Container } from "react-bootstrap";

class Footer extends Component {
  render() {
    return (
      <footer className="footer px-0 px-lg-3">
        <Container fluid>
          <nav>
            <p className="copyright text-center">
              © {new Date().getFullYear()}{" "}
              <a href="http://www.huaca.gob.ec">Huaca</a>
            </p>
          </nav>
        </Container>
      </footer>
    );
  }
}

export default Footer;
